import { render, staticRenderFns } from "./PurchaseProgram.vue?vue&type=template&id=30b1237a&"
import script from "./PurchaseProgram.vue?vue&type=script&lang=js&"
export * from "./PurchaseProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports